export enum EnumAppMode {
  Sales = 'sales',
  Business = 'business',
}
